import { api } from '@/services'

export const list = (params) => {
  return api.get('/admin/splitConfiguration/list', { params })
}

export const show = (id) => {
  return api.get(`/admin/splitConfiguration/show/${id}`)
}

export const remove = (id) => {
  return api.delete(`/admin/splitConfiguration/delete/${id}`)
}

export const create = (splitConfiguration) => {
  return api.post('/admin/splitConfiguration/create', splitConfiguration)
}
